import gql from 'graphql-tag'

export default gql`
  mutation AddDownvoteOnUser($user: ID!, $entry: ID!) {
    addToDownvoteOnUser (
      downvoteUsersUserId: $user,
      downvotedEntryId: $entry
    ) {
      downvotedEntry {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/MUTATION_ADD_DOWNVOTE_ON_USER.js